import LiveCommentsComponent from "./LiveCommentsComponent";

export default LiveCommentsComponent